import { z } from "zod";

// Input Form Validation Schema
export const validationSchema = z.object({
  email: z
    .string()
    .min(1, { message: "Email address is required" })
    .email("This is not a valid email."),
  password: z.string().min(1, { message: "Password is required." }),
});
